<bee-user-notifications-bell *ngIf="authenticationService.isLoggedIn()" [userNotifications]="userNotifications"
    [settings]="moi.settings.content.settings"></bee-user-notifications-bell>